export enum BuilderLeaderboardTabs {
  leaderboard = 'leaderboard',
  prizes = 'prizes',
}
